<div class="row align-items-center" [ngClass]="{ 'border-bottom': config.sticky }">
  <div class="col d-flex align-items-center">
    @if (!hideNavigation) {
      <div class="d-flex" style="flex: 1; max-width: 840px; margin-right: 16px">
        <!-- Portfolio section -->
        @if (!hidePortfolio) {
          <div #portfolioPos class="col-4 mb-0 px-1 pr-2">
            <div
              data-testid="navigation-select-portfolio-button"
              [ngClass]="{ selected: selectedLevel === 'portfolio' }"
              class="custom-border clickable"
              (click)="selectPortfolio($event)">
              <div class="row mr-0 ml-0">
                  <div class="col-2 pr-1 pl-0 align-vertical-center">
                  <i class="far fa-globe-americas portfolio-icon text-primary" role="img"
                    [attr.aria-label]="'IMAGE_DESCRIPTION.PORTFOLIO_IMAGE' | translate"></i>
                  </div>
                  <div class="col-6 pl-0 pr-1">
                    <div class="row m-0 w-100">
                    <label
                        #portfolioLabel
                        #portfolioTooltip="matTooltip"
                        class="navigation-ellipsis-label text-primary font-weight-bold m-0 text-truncate d-block w-100"
                        [ngClass]="{ selected: selectedLevel === 'portfolio' }"
                        [matTooltip]="selectedPortfolio?.name"
                        matTooltipClass="tooltip-nowrap"
                        (mouseenter)="checkEllipsis(portfolioLabel, portfolioTooltip)">
                      {{ selectedPortfolio?.name }}
                    </label>
                  </div>
                    <div>
                  @if (selectedPortfolio?.powerplants.length) {
                        <label class="text-primary font-size-very-small m-0"
                      [ngClass]="{ selected: selectedLevel === 'portfolio' }">
                      @if (config?.selected.length !== selectedPortfolio?.powerplants.length && selectedLevel === 'portfolio') {
                        <span>
                          {{ config?.selected.length }} {{'COMMON.OF' | translate}}
                        </span>
                      }
                      {{ selectedPortfolio?.powerplants.length }} {{'COMMON.PARKS' | translate}}
                    </label>
                    }
                  </div>
                </div>
                  <div class="col-4 pl-0 pr-1 align-vertical-center justify-content-end">
                    <div class="d-flex justify-content-end" style="gap: 8px">
                  @if (selectedLevel === 'portfolio') {
                      <ng-container
                        [ngTemplateOutlet]="buttonFilter"
                          [ngTemplateOutletContext]="{
                            level: 'filterPortfolio',
                            isFilter: true,
                            popover: overlayTemplatePortfolioFilter,
                            selected: selectedLevel === 'portfolio', 
                            filtered: shown.filterPortfolio || isFiltered('portfolio'),
                            containerClass: 'npc-portfolio',
                            disabled: isLoading || !filteredItem?.powerplants || config?.sticky
                          }">
                          </ng-container>
                  }
                    <ng-container
                      [ngTemplateOutlet]="buttonFilter"
                        [ngTemplateOutletContext]="{
                          level: 'portfolio',
                          isFilter: false,
                          selected: selectedLevel === 'portfolio',
                          filtered: shown.portfolio,
                          popover: overlayTemplatePortfolioSelection,
                          containerClass: 'npc-portfolio',
                          disabled: isLoading
                }"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Plant section -->
        @if (!hidePowerplant) {
            <div class="col-4 mb-0 pl-0 pr-2">
            <div
              data-testid="navigation-select-site-button"
              [ngClass]="{ selected: selectedLevel === 'park' }"
              class="custom-border clickable"
              (click)="selectPowerplant($event)">
              <div class="row mr-0 ml-0">
                  <div class="col-2 pl-0 pr-1 align-vertical-center">
                    <img
                      [src]="'park-navigation' | imageSrc | async"
                      class="icon-navigation" [alt]="'IMAGE_DESCRIPTION.PARK' | translate"/>
                  </div>
                <div class="col-6 pl-0 pr-2">
                      <div class="row m-0 w-100">
                    <label
                      #powerplantLabel
                      #powerplantTooltip="matTooltip"
                      class="navigation-ellipsis-label text-primary font-weight-bold m-0 text-truncate d-block w-100"
                      [ngClass]="{ selected: selectedLevel === 'park' }"
                      [matTooltip]="selectedPowerplant?.displayName"
                      matTooltipClass="tooltip-nowrap"
                      (mouseenter)="checkEllipsis(powerplantLabel, powerplantTooltip)">
                        {{ selectedPowerplant?.displayName }}
                    </label>
                    <app-site-technology-buttons
                      [supportedModules]="['overview']"
                    ></app-site-technology-buttons>
                  </div>
                  <div>
                    <label
                      class="text-primary font-size-very-small m-0"
                      [ngClass]="{ selected: selectedLevel === 'park' }">
                      @if (config?.selected.length !== selectedPowerplant?.turbines.length && selectedLevel === 'park') {
                        <span>
                          {{ config?.selected.length }} of
                        </span>
                      }
                      {{ selectedPowerplant?.turbines?.length }} {{'COMMON.TURBINES' | translate}}
                    </label>
                  </div>
                </div>
                <div class="col-4 pr-1 pl-0 align-vertical-center justify-content-end">
                  <div class="d-flex justify-content-end" style="gap: 8px">
                  @if (selectedLevel === 'park' && showSelectTurbinesButton()) {
                        <ng-container
                          [ngTemplateOutlet]="buttonFilter"
                          [ngTemplateOutletContext]="{ level: 'filterPark', isFilter: true,
                          selected: selectedLevel === 'park', filtered: shown.filterPark || isFiltered('park'),
                          popover: overlayTemplateParkFilter,
                          containerClass: 'npc-site',
                          disabled: isLoading || !filteredItem?.turbines || config?.sticky
                        }"></ng-container>
                  }
                    <ng-container
                      [ngTemplateOutlet]="buttonFilter"
                      [ngTemplateOutletContext]="{ level: 'park', isFilter: false,
                      selected: selectedLevel === 'park', filtered: shown.park,
                      popover: overlayTemplateParkSelection,
                      containerClass: 'npc-site',
                      disabled: isLoading
                      }">
                      </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Turbine section -->
        @if (!hideTurbine) {
          <div class="col-4 mb-0 pl-0">
            <div
              data-testid="navigation-select-device-button"
              [ngClass]="{ selected: selectedLevel === 'turbine' }"
              class="custom-border clickable h-100"
              (click)="selectTurbine($event)">
              <div class="row mr-0 ml-0 h-100">
                  <div class="col-2 pl-0 pr-1 align-vertical-center">
                    <img
                      [src]="'turbine-navigation' | imageSrc | async"
                      class="icon-navigation" [alt]="'IMAGE_DESCRIPTION.TURBINE' | translate" />
                  </div>
                  <div class="col pl-0 pr-1 turbine-label" >
                  <div class="d-grid align-items-center" 
                    style="gap: 4px;grid-template-columns:minmax(auto, min-content) auto" 
                    [ngClass]="{ selected: selectedLevel === 'turbine' }" >

                  <span
                      #turbineLabel
                      #turbineTooltip="matTooltip"
                      class="navigation-ellipsis-label text-primary font-weight-bold m-0 text-left text-truncate d-block w-100"
                      [class.selected]="selectedLevel === 'turbine'"
                      [matTooltip]="selectedTurbine?.codeDisplay | noUnderscore"
                      matTooltipClass="tooltip-nowrap"
                      tabindex="0"
                      (mouseenter)="checkEllipsis(turbineLabel, turbineTooltip)">
                      {{ selectedTurbine?.codeDisplay | noUnderscore }}
                    </span>

                    @if (selectedLevel === 'turbine') {
                      <span 
                        #indexTurbine 
                        class="navigation-ellipsis-label text-primary m-0 text-left text-truncate d-block w-100"
                        style="font-size:10px" >
                        ({{selectedTurbineIndex + 1 }} {{'COMMON.OF' | translate}}  {{filteredTurbines(selectedPowerplant.turbines).length}} )
                      </span>
                    }
                  </div>
                  <div>
                    <label 
                      class="text-primary font-size-very-small m-0 no-break" 
                      [ngClass]="{ selected: selectedLevel === 'turbine' }"> 
                        {{ selectedTurbine?.serialDisplay }}
                      </label>
                  </div>
                </div>
                @if (selectedLevel === 'turbine') {
                  <div class="justify-content-end row pr-1" style="gap:4px">
                    <div class="align-vertical-center"><ng-container [ngTemplateOutlet]="arrowButton" [ngTemplateOutletContext]="{forwards:false,disabled: isLoading || !hasPrevTurbine}"></ng-container></div>
                    <div class="align-vertical-center"> <ng-container   [ngTemplateOutlet]="arrowButton" [ngTemplateOutletContext]="{forwards:true,disabled: isLoading || !hasNextTurbine}"></ng-container> </div>
                  </div>
                }
                <div class="col-2 pl-0 pr-1 align-vertical-center">
                    <ng-container
                      [ngTemplateOutlet]="buttonFilter"
                      [ngTemplateOutletContext]="{ level: 'turbine', isFilter: false,
                        popover: overlayTemplateTurbineSelection,
                        selected: selectedLevel === 'turbine', filtered: shown.turbine,
                        containerClass: '',
                        disabled: isLoading || (config.sticky && selectedLevel === 'turbine')
                      }">
                    </ng-container>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="d-flex justify-content-end">
    <app-header-user-settings [headerResponsivenessOptions]="headerResponsivenessOptions"></app-header-user-settings>
  </div>
</div>

@if (config.sticky) {
  <div class="row overflow-auto mt-1 sticky-container w-100">
    @if (selectedLevel === 'portfolio') {
      <ng-container *ngTemplateOutlet="overlayTemplatePortfolioFilter"></ng-container>
    }
    @if (selectedLevel === 'park') {
      <ng-container *ngTemplateOutlet="overlayTemplateParkFilter"></ng-container>
    }
    @if (selectedLevel === 'turbine') {
      <ng-container *ngTemplateOutlet="overlayTemplateTurbineSelection"></ng-container>
    }
  </div>
}

<!-- TEMPLATES FOR PORTFOLIO OVERLAY -->

<ng-template #overlayTemplatePortfolioFilter>
  <app-header-filter
    [selectedItem]="selectedPortfolio"
    [filteredItem]="filteredItem"
    [portfolioLevel]="true"
    [defaultPortfolio]="defaultPortfolio"
    [config]="config"
    [theme]="theme$ | async"
    [disableCreate]="parkTurbineDropdownData?.portfolios?.length >= 20"
    (unpin)="unpin()"
    (changePlantSelection)="changePlantSelection()"
    (createNewPortfolio)="createNewPortfolio($event)"
    class="col-12">
  </app-header-filter>
</ng-template>

<ng-template #overlayTemplatePortfolioSelection>
  <div class="rounded p-2 template-portfolio">
    <div class="row">
      @for (
        portfolio of parkTurbineDropdownData?.portfolios; track
        portfolio; let i = $index; let last = $last) {
        <div
          (click)="navigateToPortfolio(portfolio)">
          <div
            data-testid="navigation-select-portfolio"
            class="p-2 m-1 custom-border clickable"
            [ngClass]="{'selected-element': selectedLevel === 'portfolio' && selectedPortfolio?.id === portfolio.id}"
            style="min-height: 40px; min-width: 155px">
            <div class="row">
              <div class="col-3 pr-2 d-flex align-items-center">
                <i
                  class="far fa-globe-americas portfolio-navigation-icon opacity-dark-9"
                  [attr.aria-label]="'IMAGE_DESCRIPTION.PORTFOLIO_IMAGE' | translate"
                  role="img">
                </i>
              </div>
              <div
                class="col-9 pr-1 icon-color"
                [ngClass]="{ selected: selectedLevel === 'portfolio' && selectedPortfolio?.id === portfolio.id }">
                <div>
                  <label 
                    class="font-weight-bold text-nowrap">{{ portfolio?.name }}</label>
                </div>
                <div>
                  <label class="font-size-very-small m-0">
                    {{ portfolio?.powerplants.length }} {{'COMMON.PARKS' | translate}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- TEMPLATE FOR PLANT OVERLAY -->

<ng-template #overlayTemplateParkFilter>
  <app-header-filter
    [selectedItem]="selectedPowerplant"
    [filteredItem]="filteredItem"
    [portfolioLevel]="false"
    [config]="config"
    [theme]="theme$ | async"
    (unpin)="unpin()"
    (changeTurbineSelection)="changeTurbineSelection()"
    class="col-12">
  </app-header-filter>
</ng-template>

<ng-template #overlayTemplateParkSelection>
  <div class="rounded p-2 clickable {{theme$ | async}}">
    <div class="row mb-3">
      <lib-search width="100%" class="w-100 park-search" placeholder="HEADER.SEARCH_FOR_ASSET" [value]="parkSearch" (inputChanged)="filterParks($event)"> </lib-search>
    </div>

    @if (parkTurbineDropdownData.parksGrouped) {
      <div class="row">
        @for (item of selectedPortfolio?.countries | keyvalue; track item) {
          <div class="col-12">
            <div class="row p-2">
              <lib-country-flag [countryShortname]="item?.value[0].countryCode"></lib-country-flag>
              <span class="font-weight-bold">{{item.key}}</span>
            </div>
            <div class="row">
              <ng-container
                [ngTemplateOutlet]="parksList"
                [ngTemplateOutletContext]="{parksList: item?.value}"
              ></ng-container>
            </div>
          </div>
        }
      </div>
    }
    @if (!parkTurbineDropdownData.parksGrouped) {
      <div class="row">
        <ng-container
          [ngTemplateOutlet]="parksList"
          [ngTemplateOutletContext]="{parksList: selectedPortfolio?.powerplants}"
        ></ng-container>
      </div>
    }
  </div>
</ng-template>

<!-- TEMPLATE FOR TURBINE OVERLAY -->


<ng-template #overlayTemplateTurbineSelection>
  <div class="rounded col-12 {{theme$ | async}}">
    <div class="row mt-2 mx-2 pb-3 border-bottom turbine-filters">
      <div class="col-2 pl-3 d-flex align-items-center">
        <input
          type="text"
          class="turbine-search"
          [placeholder]="'HEADER.SEARCH_FOR_ASSET' | translate"
          [(ngModel)]="searchAsset"
          (ngModelChange)="filterTurbines()">
      </div>
      <div class="col-10 pr-1 justify-content-end d-flex">
        <div class="mx-1 turbines-type-selector">
          <lib-select
            id="navigation-select-status"
            [options]="inputsShowOptions.names"
            [label]="statusSelected"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [container]="''"
            (selectedChanged)="changeStatus($event)">
          </lib-select>
        </div>
        <button class="p-1 mx-1 custom-border pin-button" (click)="pinToggle()" [disabled]="selectedLevel !== 'turbine'">
          @if (!config.sticky) {
            <img
              [alt]="'IMAGE_DESCRIPTION.PIN' | translate"
              class="opacity-dark-9"
              src="assets/images/pin/{{(theme$ | async) === 'light' ? 'pin-dark.svg' : 'pin-light.svg'}}">
            }
            @if (config.sticky) {
              <img
                [alt]="'IMAGE_DESCRIPTION.UNPIN' | translate"
                class="opacity-dark-9"
                src="assets/images/pin/{{(theme$ | async) === 'light' ? 'pinned-dark.svg' : 'pinned-light.svg'}}">
              }
            </button>
          </div>
        </div>
        <div class="rounded turbines-list-container {{theme$ | async}}">
          <div class="row p-2">
            @for (plant of filteredPlantsTurbines; track plant) {
              @if (plant?.turbines?.length && !isParkDeactivated(plant?.id)) {
                <div
                  class="col-12 mt-2 clickable" >
                <div class="row text-primary font-weight-bold mb-3 mt-2"
                  [ngClass]="{'active-element': selectedPowerplant?.id === plant?.id}">
                  <lib-country-flag [countryShortname]="plant.countryCode"></lib-country-flag>
                  &nbsp;{{ plant.displayName || plant.name }}
                </div>
                <div class="row">
                  @for (item of plant.turbines; track item; let i = $index; let last = $last) {
                    @if (item.code && !isTurbineDeactivated(item.id)) {
                      <div
                        class="pr-2 pb-2 col-1"
                        (click)="navigateToTurbine(item.id)"
                        style="min-height: 40px; min-width: 90px">
                        <div class="p-2 custom-border"
                          [ngClass]="{'selected-element': selectedLevel === 'turbine' && selectedTurbine?.id === item.id}">
                          <div class="row d-flex">
                            <div class="col-11">
                              <div class="text-left font-size-normal font-weight-bold text-primary">
                                <div class="{{isTurbineDeactivated(item.id) ? 'text-gray' : 'text-primary'}} font-weight-bold selected-item"
                                  style="font-size: 0.75rem !important">
                                  {{ item.codeDisplay | noUnderscore }}
                                </div>
                              </div>
                            </div>
                            <div class="col-1" style="margin-left: -5px">
                              @if (signalType === 'status') {
                                <i
                                  class="fas fa-circle align-self-center" [ngClass]="{ 'outline-circle': item?.state === 5 }"
                                [style.color]="item?.state | colorStatusCode:'color'"></i>
                              }
                              @if (signalType === 'load') {
                                <span>
                                  <app-load-factor [loadFactor]="item?.loadFactor"></app-load-factor>
                                </span>
                              }
                              @if (signalType === 'efficiency') {
                                <div class="efficiency-container">
                                  <app-efficiency [efficiency]="item?.efficiency"></app-efficiency>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #parksList let-parksList="parksList">
    @for (park of parksList; track park; let i = $index; let last = $last) {
      <div
        (click)="navigateToPowerplant(park.id)"
        [style.display]="showFilteredPark(park?.displayName || park.name) ? 'flex' : 'none'">
        <div class="p-2 m-1 custom-border"
          [ngClass]="{'selected-element': selectedLevel === 'park' && selectedPowerplant?.id === park.id}"
          style="min-height: 40px; min-width: 130px">
          <div class="row">
            <div class="col-11">
              <label
                class="{{isParkDeactivated(park.id, park.energyMeterAvailable) ? 'text-gray' : 'text-primary'}} font-size-normal m-0 font-weight-bold custom-park-label"
                [ngClass]="{selected: selectedLevel === 'park' && selectedPowerplant?.id === park.id}">
                {{ park?.displayName || park.name }}
              </label>
            </div>
            <div class="col-1">
              @if (config.signalType === 'status') {
                <i
                  class="fas fa-circle align-self-center" [ngClass]="{ 'outline-circle': park?.state === 5 }"
                  [style.color]="park?.state | colorStatusCode:'color'">
                </i>
              }
              @if (signalType === 'load') {
                <span>
                  <app-load-factor [loadFactor]="park?.loadFactor"></app-load-factor>
                </span>
              }
              @if (signalType === 'efficiency') {
                <div class="efficiency-container">
                  <app-efficiency [efficiency]="park?.efficiency"></app-efficiency>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #buttonFilter let-selected="selected" let-filtered="filtered" let-level="level" let-containerClass="containerClass"
    let-disabled="disabled" let-popover="popover" let-isFilter="isFilter">
    <button
      [ngClass]="{ selected, filtered }"
      class="btn py-0 p-0 button-border"
      style="height: 1.8rem"
      [outsideClick]="true"
      [popover]="popover"
      (onShown)="isFilter ? onShownFilter(level) : onShown(level)"
      (onHidden)="onHidden(level)"
      (click)="$event.stopPropagation()"
      [isOpen]="shown[level]"
      container="body"
      [adaptivePosition]="level !== 'portfolio' && level !== 'filterPortfolio'"
      placement="bottom"
      [containerClass]="'navigation-popover-container shadow ' + containerClass + ' ' + (theme$ | async)"
      [disabled]="disabled">
      @if (!isFilter) {
        <div class="h-100 d-flex align-items-center">
          <i
            class="far {{ filtered ? 'fa-chevron-up' : 'fa-chevron-down' }} cursor-pointer text-primary ml-2 mr-2 font-size-small icon-color"
            [ngClass]="{ selected: selected && !filtered }">
          </i>
        </div>
      } @else {
        <div class="h-100 d-flex align-items-center filter-img">
          <img
            class="opacity-dark-9"
            [src]="'assets/images/filter/'+ (((theme$ | async) === 'dark') ? 'filter-light' : 'filter-dark') + '.svg'"
            [alt]="'IMAGE_DESCRIPTION.FILTER' | translate" >
        </div>
      }
    </button>
  </ng-template>


  <ng-template #arrowButton let-forwards="forwards" let-disabled="disabled">
    <button
      class="btn p-0 selected button-border"
      style="height: 1.8rem; width: 1.82rem;"
      [ngStyle]="{ 'cursor': disabled ? 'default' : 'pointer', 'opacity' : disabled ? '0.5' : '1' }"
      (click)="goToNextTurbine(forwards)"
      [disabled]="disabled">
      <div class="h-100 d-flex align-items-center">
        <i class="fas {{ forwards ? 'fa-chevron-right' : 'fa-chevron-left' }} text-primary mx-auto font-size-small icon-color" style="cursor: inherit;">
        </i>
      </div>
    </button>
  </ng-template>
